var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 11.4,
    height: 11.4,
    rx: 5.7,
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85001 5.9999C2.85001 5.87564 2.95074 5.7749 3.07501 5.7749H8.92501C9.04927 5.7749 9.15001 5.87564 9.15001 5.9999C9.15001 6.12417 9.04927 6.2249 8.92501 6.2249H3.07501C2.95074 6.2249 2.85001 6.12417 2.85001 5.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRound);
export default __webpack_public_path__ + "static/media/MinusRound.9b94bef2acd9e88e97b4ffad31ca63ab.svg";
export { ForwardRef as ReactComponent };